export const BACKEND_URL = process.env.REACT_APP_BACKEND;

export const getStoredEndpoints = () => {
  const storedEndpoints = localStorage.getItem('apiEndpoints');
  return storedEndpoints ? JSON.parse(storedEndpoints) : {};
};

export const setStoredEndpoints = (endpoints) => {
  localStorage.setItem('apiEndpoints', JSON.stringify(endpoints));
};